import { createApp } from 'vue';
import App from './app';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserSecret } from '@fortawesome/free-solid-svg-icons';
import versionCheck from '@utils/version-check';
import DayJs from '@utils/dayjs-initialize';

library.add(faUserSecret);

const app = createApp(App);
app.use(versionCheck);
app.use(DayJs);

app.mount('#app');
